import { z } from "zod";

export const backofficeFindLastSoftwareUpdateResponse = z.void().or(
  z
    .object({
      datePrepared: z.coerce.date(),
    })
    .nullish(),
);
